module.exports = __webpack_public_path__ + "img/gonghui.9703fc37.png";